module.exports = __webpack_public_path__ + "3320aba7e8f34458ee7dd0302290e7c3.svg";


//////////////////
// WEBPACK FOOTER
// ./images/back_arrow_ov.svg
// module id = 94
// module chunks = 0